import React from 'react';
import { getLabel } from '../../../../data/labels';
import SportItem from './SportItem';
import { getConfiguration } from '../../../../data/utils';

function FavoriteTournaments(props) {
    const conf = getConfiguration();
    const inEvidenzaItems = props.data.sportsList.map(function(sport) {
        return <SportItem key={sport.id} {...sport} />
    });

    return (
        <div id="favorite-tournaments" className="contenitore-competizioni-sport" role="tablist" aria-multiselectable="true">
            <div className="card elemento-competizioni-widget">
                <div className="titolo-accordion maiuscolo bianco d-flex d-centro-v pointer toggle-nascondi-live tog-menu" data-toggle="collapse" data-parent="#favorite-tournaments" href="#favorite-tournaments-menu">
                    <a href="#!" className="d-flex d-centro-v maiuscolo grassetto">
                        {getLabel('menu_prematch.favorite_tournaments')}
                    </a>
                    <span className='favorite__tournamentsCount' > { conf.iwh ? `(${props.data.tournamentsCount})` : props.data.tournamentsCount}</span>
                </div>
                <div id="favorite-tournaments-menu" className="competzioni-sub collapse in margine-su-mezzo show" role="tabpanel" aria-labelledby="favorite-tournaments">
                    {inEvidenzaItems}
                </div>
            </div>
        </div>
    );
}

export default FavoriteTournaments;